<div class="wrapper">
    <div class="inner">
        <h1>Passwort zurücksetzen</h1>
        <form [formGroup]="passwordResetForm" (ngSubmit)="onSubmit()" (keydown.enter)="$event.preventDefault()">
            <div class="left-column">
                <div>
                    Geben Sie Ihre E-Mail-Adresse ein, um Ihr Passwort
                    zurücksetzen.
                    <div>
                        <!------------------------------------------------------------------->
                        <mat-form-field class="stretch">
                            <mat-label>Email</mat-label>
                            <input matInput type="email" [formControl]="email" autocomplete="email"
                                required />
                            <mat-error *ngIf="email.errors?.required">Bitte geben sie eine E-Mail an</mat-error>
                            <mat-error *ngIf="
                                    email.errors?.pattern &&
                                    !email.errors?.required
                                ">Bitte geben Sie eine valide E-Mail
                                an</mat-error>
                        </mat-form-field>
                        <div></div>
                        <div class="buttons">
                            <button type="button" matButton="elevated" color="warn" (click)="onCancel()">
                                Abbrechen
                            </button>
                            <button matButton="elevated" class="green-confirm" type="submit" [disabled]="!email.valid">
                                Passwort zurücksetzen
                            </button>
                        </div>
                    </div>
                    <!------------------------------------------------------------------->
                </div>
            </div>
        </form>
    </div>
</div>